import handleResponse from './request/handleSettingsResponse'

export default function(api: GlobalFetch) {
  return async function(id: string) {
    const requestBody = {
      id: id,
      // eslint-disable-next-line @typescript-eslint/camelcase
      pricelist_version: '2',
    }
    const response = await api.fetch(`/api/v2/object/index`, {
      body: JSON.stringify(requestBody),
      method: 'PUT',
    })
    return await handleResponse(response)
  }
}
